import React, { useState } from 'react';
import defaultProductImage from '@/assets/images/default-product.svg';

interface ProductImageProps {
  name: string;
  src?: string | null;
  className?: string;
}

const ProductImage: React.FC<ProductImageProps> = ({ name, src, className = '' }) => {
  const [hasError, setHasError] = useState(false);
  const imageSource = src && !hasError ? src : defaultProductImage;

  return (
    <div className={`flex shrink-0 items-center justify-center overflow-hidden border border-outline-variant bg-surface-container-low ${className}`}>
      <img
        className="h-full w-full object-cover"
        src={imageSource}
        alt=""
        onError={() => setHasError(true)}
      />
      <span className="sr-only">{name}</span>
    </div>
  );
};

export default ProductImage;
